export const TIP_TEXT = "Hover over a country on the map to see the number of registered drugs for the country. " +
    "Click on a country on the map to see details and statistics about the country.";

export const ABOUT_TEXT = "The web site contains data that is used from multiple web pages and sources. In order to find more details about the web sites, file a complain or contact us click the links below.";

export const drugsGroups = {
    "A": "Alimentary tract and metabolism",
    "B": "Blood and blood forming organs",
    "C": "Cardiovascular system",
    "D": "Dermatologicals",
    "G": "Genito-urinary system and sex hormones",
    "H": "Systemic hormonal preparations, excluding sex hormones and insulins",
    "J": "Antiinfectives for systemic use",
    "L": "Antineoplastic and immunomodulating agents",
    "M": "Musculo-skeletal system",
    "N": "Nervous system",
    "P": "Antiparasitic products, insecticides and repellents",
    "R": "Respiratory system",
    "S": "Sensory organs",
    "V": "Various"
};
